import { racquetOutcome } from '../../../shared/racquetOutcome.mjs'
import { pointLabels } from '../../../shared/racquetScoreDomain.mjs'

export function racquetFinishOutcome(s) {
  const outcome = racquetOutcome(s)
  if (outcome.winner) return 'winner'
  if (outcome.unfinished || !s.segments.length) return 'unfinishedOutcome'
  return outcome.wins[0] === outcome.wins[1] ? 'tiedOutcome' : 'finishedOutcome'
}

/** Team names wrap independently of numeric columns. Wider scorecards scroll. */
export default function RacquetFinishSummary({ state: s, t, teamName }) {
  const racket = ['tennis', 'padel'].includes(s.rules.sport)
  const current = racket ? s.games : s.points
  const showCurrent = current.some(Boolean) || s.points.some(Boolean)
  const showPoints = racket && s.points.some(Boolean)
  const outcome = racquetFinishOutcome(s), result = racquetOutcome(s)
  return <div className="rp-finish-summary">
    <p className="rp-finish-outcome">{outcome === 'winner'
      ? <><span>{t('winner')}</span> · <strong>{teamName(s.teams.find(team => team.id === result.winner))}</strong></>
      : <span>{t(outcome)}</span>}{s.segments.length > 0 && <small className="rp-finish-total">{result.wins.join('–')} {t(result.unit)}</small>}</p>
    <div className="rp-finish-table-scroll" tabIndex={0} role="region" aria-label={t('scorecard')}>
      <table className="rp-finish-table">
        <thead><tr><td />{s.segments.map((_, i) => <th key={i} scope="col">{t(racket ? 'set' : 'game')} {i + 1}</th>)}
          {showCurrent && <th scope="col">{t('unfinishedColumn')}</th>}
          {showPoints && <th scope="col">{t('points')}</th>}
        </tr></thead>
        <tbody>{s.teams.map((team, i) => <tr key={team.id} data-team-colour={i === 0 ? 'emerald' : 'blue'}>
          <th scope="row"><span>{teamName(team)}</span></th>
          {s.segments.map((seg, j) => <td key={j}>{seg.score[i]}</td>)}
          {showCurrent && <td>{current[i]}</td>}
          {showPoints && <td>{pointLabels(s)[i] === 'AD' ? t('advantage') : pointLabels(s)[i]}</td>}
        </tr>)}</tbody>
      </table>
    </div>
  </div>
}
